import React from 'react'
import WelcomeComponent from '../components/WelcomeComponent'
import TeamComponent from '../components/TeamComponent'
function About() {
  return (
    <div>
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                About Us
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center">
                  <li className="breadcrumb-item ">
                    <a href="/">Home</a>
                  </li>
                  {/* <li className="breadcrumb-item">
                <a href="/Pages">Pages</a>
              </li> */}
                  <li
                    className="breadcrumb-item text-white active"
                    aria-current="page"
                  >
                    About
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      {/* About Start */}
  <WelcomeComponent/>
      {/* About End */}
      {/* Team Start */}
 <TeamComponent/>

      {/* Team End */}
    </div>
  )
}

export default About